"use strict"

import React, {useEffect} from "react"
import {observer} from "mobx-react"

import {injectIntl} from "react-intl"
import {Container, Typography, Grid, Box, Link} from "@material-ui/core"
import XsButton from "../../global/ui/xsButton/xsButton"
import RouterStore from "../../global/store/RouterStore"
import api from "../../global/actions/api"

function MinContainer() {
	useEffect(() => {
		api.appInfo().call()
	}, [])

	return (
		<Container maxWidth="md">
			<Grid container direction="column" spacing={8}>
				<Grid item>
					<Box pt={8}>
						<Typography variant="h3">Žiadosti o vydanie poukážky</Typography>
					</Box>
				</Grid>
				<Grid item container direction="column" spacing={4}>
					<Grid item>
						<XsButton fullWidth={false} text="REGISTROVAŤ ŽIADATEĽA" onClick={() => RouterStore.push("/register")} />
					</Grid>
					<Grid item>
						<Typography variant="body2">
							Pre prihlásenie do informačného systému je potrebné sa najprv zaregistrovať.
						</Typography>
					</Grid>
				</Grid>
				<Grid item container direction="column" spacing={4}>
					<Grid item>
						<XsButton fullWidth={false} text="PRIHLÁSENIE" onClick={() => RouterStore.push("/login")} />
					</Grid>
					<Grid item>
						<Typography variant="body2">
							Pre vstup do konta je nutné zadať prihlasovacie meno (email) a heslo. Použite údaje, ktoré boli vytvorené
							pri registrácii.
						</Typography>
					</Grid>
				</Grid>
				<Grid item container direction="column" spacing={4}>
					<Grid item>
						<XsButton fullWidth={false} text="PORADOVNÍK ŽIADOSTÍ" onClick={() => RouterStore.push("/waiting")} />
					</Grid>
					<Grid item>
						<Typography variant="body2">
							Poradovník žiadostí o vydanie poukážky je verejný a zobrazuje aktuálne disponibilnú výšku alokácie.
						</Typography>
					</Grid>
				</Grid>
				<Grid item container direction="column" spacing={1} style={{marginTop: "16px"}}>
					<div style={{border: "1px solid #b6b6b6", borderRadius: "12px", padding: "16px"}}>
						<Grid item>
							<Box>
								<Typography variant="body2" style={{fontWeight: "bold"}}>
									Registráciu v Informačnom systéme je možné zrušiť:
								</Typography>
							</Box>
						</Grid>
						<Grid item>
							<Typography variant="body2">1. nepotvrdením registrácie v lehote 72 hodín</Typography>
						</Grid>
						<Grid item>
							<Typography variant="body2">
								2. zaslaním žiadosti o zrušenie registrácie na{" "}
								<Link className="pointer" onClick={() => window.open("mailto:zelenapodnikom@siea.gov.sk")}>
									zelenapodnikom@siea.gov.sk
								</Link>
								, pričom táto musí byť zaslaná z registračného mailu (Prihlasovacie meno/email) k danému IČO
							</Typography>
						</Grid>
						<Grid item>
							<Typography variant="body2">
								3. zaslaním žiadosti o zrušenie registrácie na{" "}
								<Link className="pointer" onClick={() => window.open("mailto:zelenapodnikom@siea.gov.sk")}>
									zelenapodnikom@siea.gov.sk
								</Link>
								, pričom táto musí byť zaslaná osobou oprávnenou konať za spoločnosť v zmysle OR SR k danému IČO
							</Typography>
						</Grid>
						<Grid item>
							<Typography variant="body2">
								Registráciu je možné zrušiť za podmienky, že v rámci konta nie je registrovaná alebo podaná žiadosť o
								vydanie poukážky.
							</Typography>
						</Grid>
					</div>
				</Grid>
			</Grid>
		</Container>
	)
}

export default injectIntl(observer(MinContainer))

